/**
 * Created by pandemio on 4/16/19.
 */
import React from 'react';
import { Button} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import ApiCalls from '../../custom-classes/api-calls';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSyncAlt, faTasks} from '@fortawesome/free-solid-svg-icons';
import LoaderFullWindow from '../loader-windows/loader-full-window';
/**
 * Class that handles the modal
 */
class TableActivity extends React.Component {
    constructor(props) {
        super(props);
        let languages = [
            { name: "English", code: "en" },
            { name: "Español", code: "es" }
        ];

        this.state = {
            rows: [],
            modal: false,
            activityData: null,
            languages: languages,
            isLoading: false
        };
        this.callProfilesActivities = this.callProfilesActivities.bind(this);
    }


    /**
     * Prepare it for the first view with the data included
     */
    componentWillMount(){
        this.callProfilesActivities();
    }

    /**
     * Calls the profile last activities (we cut it to 3)
     */
    callProfilesActivities(){
        this.setState({
            isLoading: true
        },()=>{
            let apiCall = ApiCalls.getProfilesActivity();
            apiCall.then((data)=>{

                if(data.ProfilesActivities !== null) {
                    let rows = [];
                    for (let i = 0; i < data.ProfilesActivities.length; i++) {
                        if (i === 3)
                            break;
                        // If active, add the button;
                        let row =
                            <div key={i} className="border-bottom">
                                <b>{data.ProfilesActivities[i].StudentName}</b>
                                <br/>
                                <small>{data.ProfilesActivities[i].CreatedDate}</small>
                                <br/>
                                <Translate id="table-activity.made"/>
                                {
                                    data.ProfilesActivities[i].IsExam ?
                                        <Translate id="table-activity.exam"/> :
                                        <Translate id="table-activity.practice"/>
                                }
                                {' '}
                                <Translate id="table-activity.score"/> {' '}
                                {  data.ProfilesActivities[i].TotalPercent }{' '}
                                <Translate id="table-activity.course"/> {' '}
                                {  data.ProfilesActivities[i].Subject }{' '}
                                <Translate id="table-activity.grade"/> {' '}
                                {  data.ProfilesActivities[i].Level } {' '}
                            </div>;
                        rows.push(row);
                    }
                    this.setState({rows:rows, isLoading: false});
                }
            });
        });
    }


    render() {
        if(this.state.rows.length === 0)
            return (
                <div>
                    <Translate id="table-activity.no-activity" options={{renderInnerHtml: false}}/>
                    {' '}
                    <div className="text-right">
                        <Button color="warning" onClick={this.callProfilesActivities}>
                            <FontAwesomeIcon icon={faSyncAlt}/>{' '}
                            <Translate id="table-activity.refresh" options={{renderInnerHtml: false}}/>
                        </Button>
                    </div>
                </div>);

        return (
                <div className="centered-text">
                    <FontAwesomeIcon icon={faTasks} />{' '}
                    <Translate id="table-activity.last-activity" options={{renderInnerHtml: false}}/>
                    <hr/>
                    <div className="text-left">
                    { this.state.rows !== "0" ? this.state.rows : null }
                    </div>
                    <div className="text-right">
                        <Button color="warning" onClick={this.callProfilesActivities}>
                            <FontAwesomeIcon icon={faSyncAlt}/>{' '}
                            <Translate id="table-activity.refresh" options={{renderInnerHtml: false}}/>
                        </Button>
                    </div>
                    {
                        this.state.isLoading ?
                        <LoaderFullWindow/> : null
                    }
                </div>
        );
    }
}
export default TableActivity;